/**
 * Created by Ethan on 2017/9/8.
 */

export const LanguageMap = {
    "zh-CN": '中文',
    "en-US": 'English',
    "ja-JP": '日本語'
};

export const LanguageArray = ["zh-CN", "en-US", "ja-JP"];

// 存储访问令牌的键
export const CACHE_ACCESS_TOKEN = 'CACHE_ACCESS_TOKEN';
export const CACHE_SESSION_USER = "CACHE_SESSION_USER";
export const CACHE_SESSION_EMPLOYEE = "CACHE_SESSION_EMPLOYEE";
export const CACHE_BROKER_INFO = "CACHE_BROKER_INFO";
export const CACHE_CURRENT_CITY = "CACHE_CURRENT_CITY";
export const CACHE_CHOOSE_LOCATION = "CACHE_CHOOSE_LOCATION";

// 上传文件服务的访问地址
// export const FTP_SERVER_HOST = "http://localhost:8120"; // Dev
// export const FTP_SERVER_HOST = "http://reliable-uat-svr.iidooo.com:8120"; // Test
export const FTP_SERVER_HOST = "https://data-service.chinanestor.com";

// 账户管理微服务
// export const ACCOUNT_SERVER_HOST = "http://47.103.119.190:8880"; // Dev
// export const ACCOUNT_SERVER_HOST = "http://reliable-uat-svr.iidooo.com:8880"; // Test
export const ACCOUNT_SERVER_HOST = "https://org-service.chinanestor.com";

// 区域服务
// export const DISTRICT_SERVER_HOST = "http://localhost:8120"; // Dev
export const DISTRICT_SERVER_HOST = "https://data-service.chinanestor.com";// Prod

// 组织管理微服务
// export const ORG_SERVER_HOST = "http://localhost:8881"; // Dev
// export const ORG_SERVER_HOST = "http://reliable-uat-svr.iidooo.com:8881"; // Test
export const ORG_SERVER_HOST = "https://org-service.chinanestor.com";

// 工业仓储微服务
// export const WMS_SERVER_HOST = "http://192.168.0.107:8120";
// export const WMS_SERVER_HOST = "http://reliable-uat-svr.iidooo.com:8120"; // Test
// export const WMS_SERVER_HOST = "https://home-service.chinanestor.com";// Prod
// export const WMS_SERVER_HOST = "https://test-web-api.ixuanzhi.com";// Test
export const WMS_SERVER_HOST = "https://web-api.ixuanzhi.com";// Prod

// 短信服务
export const SMS_SERVER_HOST = "https://sms-service.chinanestor.com"; // Prod

export const WMS_DATA_SERVER_HOST = "https://data-service.chinanestor.com";// Prod
// export const WMS_DATA_SERVER_HOST = "http://localhost:8120";// Prod


export const CMS_SERVER_HOST = 'https://cms-service.ixuanzhi.com'

// 邮件发送服务
// export const MAIL_SERVER_HOST = "http://47.103.119.190:8890"; // Dev
// export const MAIL_SERVER_HOST = "http://reliable-uat-svr.iidooo.com:8890"; // Test
export const MAIL_SERVER_HOST = "https://email-service.chinanestor.com";
// 是否开放注册功能
export const REGISTRABLE_FLAG = false;
// 是否开放找回密码功能

export const FORGET_PASSWORD_FLAG = false;

// 密码强度分三档，1：无限制，2：长度超过8位，3：长度+字母数字特殊符号组合
export const PASSWORD_STRENGTH_LEVEL = 3;
